import {
    FETCH_AI_AGENT_COMMANDS,
    CLEAN_AI_AGENT_COMMANDS,
} from '../actions/types';

const AI_AGENT_COMMANDS_DEFAULT_STATE = {};

const AiAgentCommandsReducer = (state = AI_AGENT_COMMANDS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_AGENT_COMMANDS:
            return payload;

        case CLEAN_AI_AGENT_COMMANDS:
            return AI_AGENT_COMMANDS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiAgentCommandsReducer;
